
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/internet/high-speed-internet-services",
      function () {
        return require("private-next-pages/shop/internet/high-speed-internet-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/internet/high-speed-internet-services"])
      });
    }
  